import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-m-4" }
const _hoisted_2 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Message = _resolveComponent("Message")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.workspaceDataShareDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workspace.myData.shareDataset')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.shareDataset(false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('workspace.myData.unshareDataset')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.shareDataset(true))),
          disabled: !_ctx.dataset.catTypeId
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Message, {
        class: "p-m-4",
        severity: "info",
        closable: false,
        style: _ctx.workspaceDataShareDialogDescriptor.styles.message
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workspace.myData.shareDatasetHint')), 1)
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode("div", _hoisted_1, [
        _createVNode("span", null, [
          _createVNode(_component_Dropdown, {
            class: "kn-material-input",
            modelValue: _ctx.dataset.catTypeId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataset.catTypeId = $event)),
            options: _ctx.datasetCategories,
            optionLabel: "VALUE_NM",
            optionValue: "VALUE_ID"
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}